// Page: offer-unavailable  (entry-not-found "project not found" panel)
//
// Ported from the inline <script> in
//   Enrollment_modules/entry-not-found/offer-unavailable.module/module.html
//
// The module is 368 lines but almost entirely commented-out (an abandoned custom
// form + validators). The ONLY live behaviour is the "Log In" link, which swaps
// the project-not-found widget for the returning-user widget on the same page.
//
// DELIBERATE CHANGES (behaviour-preserving):
//   1. The #projectNotFoundLogIn click is bound scoped to `root` (it lives inside
//      this module). The two cross-widget wrappers it toggles
//      (#Page_0_Project_not_Found_widget / #page_0_returning_user_widget) are
//      HubSpot render-time page wrappers, so they stay document-scoped — exactly
//      as in the original.
//   2. Dropped the module's own <script src> jQuery 3.6.4 tag: it duplicated the
//      pinned jQuery in base.html and was only used by the commented-out form.

export function init(root: HTMLElement): void {
__ea_trace("modules/savings/offer-unavailable.ts","init",[root],["root"]);
  const logIn = root.querySelector<HTMLElement>("#projectNotFoundLogIn")
  logIn?.addEventListener("click", () => {
__ea_trace("modules/savings/offer-unavailable.ts","(anon)",[],[]);
    const pnf = document.getElementById("Page_0_Project_not_Found_widget") as HTMLElement
    const ru = document.getElementById("page_0_returning_user_widget") as HTMLElement
    pnf.style.display = "none"
    ru.style.display = "block"
  })
}
